import selectInsurance from 'utils/selectInsurance';

const getPatientMedicareID = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  if (selectedInsurance
    && selectedInsurance['Claim Filling Code']
    && selectedInsurance['Claim Filling Code'].ID === 5) { // ID for Medicare
    return selectedInsurance['Insurance ID'];
  }
  return null;
};

export default getPatientMedicareID;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientMedicareID.js